import React, { useState } from 'react';
import classnames from 'classnames';
import {FormattedHTMLMessage, FormattedMessage, useIntl} from 'react-intl';
import MessageWithRuleEvaluation from "@ignitesales/neuro-application/src/components/MessageWithRuleEvaluation";
import { getMessageValue } from '@ignitesales/neuro-application/src/i18n/messageUtil';
import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent";
import Modal from "@ignitesales/react-modal";
import ReactSVG from 'react-svg';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {useAppContext} from "../AppContext";
import getProductIcon from "../utils/getProductIcon";

const Product = ({isSelected, onAddCartClick, onRemoveCartClick, onProductDetailsClick, product}) => {
  const intl = useIntl();
  const appContext = useAppContext();
  const [ showModal, setShowModal ] = useState(false);
  const cssBEM = 'product';
  const icon = getProductIcon({ product });
  const descriptionId = getMessageValue(intl.locale, `${product.id}.description.abbreviated`) ? `${product.id}.description.abbreviated` :  `product.noDescription`;
  const productUrl = getMessageValue(intl.locale, `${product.id}.url`) || '#!';
  const productsThatHaveNoModal = [];

  const cartButtonAction = isSelected ? onRemoveCartClick : onAddCartClick;
  const cartButtonMessageId = isSelected ? 'cart.remove' : 'cart.add';
  const cartButtonClasses = classnames('btn', 'btn-outline-primary', 'product-cart-btn', {
    'product-cart-btn--add': !isSelected,
    'product-cart-btn--remove': isSelected
  });
  const cartButton = <button
    className={cartButtonClasses}
    aria-label={intl.formatMessage({ id: cartButtonMessageId })}
    onClick={cartButtonAction}>
    <FormattedMessage id={cartButtonMessageId} />
  </button>;

  const onDetailsClick = () => {
    onProductDetailsClick(product.id);
    setShowModal(true);
  };

  const onProductUrlClick = () => {
    const params = {
      actionName: 'productUrlClicked',
      productId: product.id
    };
    actionCompleted(params);
  };

  const renderProductFeatures = () => {
    const count = parseInt(getMessageValue(intl.locale, `${product.id}.features.count`) || "0");
    const features = Array(count).fill(1).map((v, index) => {
      const msgIndex = index + 1;
      const id = `${product.id}.features.${msgIndex}`;
      return <MessageWithRuleEvaluation id={id} key={id}>
        <FormattedHTMLMessage id={id} tagName="li"/>
      </MessageWithRuleEvaluation>;
    });
    return features.length ? <div className={`${cssBEM}__features`}>
      <FormattedMessage id="product.features.title" tagName="div" />
      <ul>{features}</ul>
    </div> : null
  };

  const renderServices = () => {
    const messages = [];
    let continueSearching = true;
    let index = 1;
    while (continueSearching) {
      const msgId = `${product.id}.whyBest.${index}.message`;
      const msg = getMessageValue(intl.locale, msgId);
      if(msg){
        messages.push(msgId);
        index++;
      }else {
        continueSearching = false;
      }
    }

    return messages.length ? <div className={`${cssBEM}__features`}>
      <FormattedMessage id="product.services.title" tagName="div" />
      <span>
        { messages.map( (msg, index) => {
          const max = messages.length - 1;
          const formattedMsg = <FormattedHTMLMessage key={index} id={msg} />
          return index === max ? formattedMsg : <>{formattedMsg}, </>
        })}
      </span>
    </div> : null
  };

  const renderProductDisclosures = () => {
    const count = getMessageValue(intl.locale, `${ product.id }.disclosures.count`);
    const features = Array(count).fill(1).map((v, index) => {
      const msgIndex = index + 1;
      const id = `${ product.id }.disclosures.${ msgIndex }`;
      return <MessageIfPresent id={ id } key={ id }>
        <FormattedHTMLMessage id={ id } tagName="li"/>
      </MessageIfPresent>;
    });
    return (features.length) ? <div className={ `${ cssBEM }__disclosures` }>
      <FormattedHTMLMessage id="product.disclosures" tagName="div" />
        <ol>{ features }</ol>
    </div> : null;
  };

  const renderModal = () => {
    const header = <div className={`${cssBEM}__details-header`}>
      <FormattedHTMLMessage id="product.seeDetails.header" tagName="span"/>
      <a href={productUrl} target="_blank"><FormattedHTMLMessage onClick={onProductUrlClick} id={`${product.id}.name`} tagName="h3"/></a>
    </div>;

    return <Modal
      className={`${cssBEM}__modal`}
      show={showModal}
      onClose={() => setShowModal(false)}
      title={header}
      closeBtn={appContext.modalCloseBtn}
      nodeId="root"
    >
      <div className={`${cssBEM}__modal-info`}>
        <PerfectScrollbar>
          <div className={`${cssBEM}__description`}><FormattedHTMLMessage id={descriptionId} /></div>
          { renderProductFeatures() }
          { renderServices() }
          { renderProductDisclosures() }
        </PerfectScrollbar>
      </div>
      <div className={`${cssBEM}__actions`}>{ cartButton }</div>
    </Modal>;
  };

  return <div className={cssBEM}>
    <div className={`${cssBEM}__title`}>
      <ReactSVG src={icon} />
      <a href={productUrl} target="_blank"><FormattedHTMLMessage id={`${product.id}.name`} tagName="h4"/></a>
    </div>

    <div className={`${cssBEM}__description`}><FormattedHTMLMessage id={descriptionId} /></div>

    <div className={`${cssBEM}__actions`}>
      { cartButton }

      {
        productsThatHaveNoModal.includes(product.id)
          ?
          <a href={productUrl} target="_blank" className="btn btn-primary product-details-btn">
            <FormattedHTMLMessage id='product.seeDetails' />
          </a>
          :
          <button className="btn btn-primary product-details-btn" onClick={onDetailsClick}>
            <FormattedHTMLMessage id='product.seeDetails' />
          </button>
      }
    </div>

    { showModal ? renderModal() : null }
  </div>;
};

export default Product;
